/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import { Box, Checkbox, Link, Typography } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { getMessageKey } from '../../../utils/utils';

function AddToExport({ allColumnsData, setAllColumnsData, selectedTab }) {
  const intl = useIntl();
  const { messages } = useSelector((state) => state?.user || {});
  const selectedTabColumns = allColumnsData[selectedTab];
  const notIncludedColumns = selectedTabColumns?.filter(
    (item) => !item.isChecked
  );

  const handleChange = (id) => {
    const updatedColumns = selectedTabColumns?.map((item) =>
      item.id === id ? { ...item, isChecked: true } : item
    );

    setAllColumnsData({
      ...allColumnsData,
      [selectedTab]: updatedColumns,
    });
  };

  const addAll = () => {
    const updatedColumns = selectedTabColumns?.map((item) => ({
      ...item,
      isChecked: true,
    }));

    setAllColumnsData({
      ...allColumnsData,
      [selectedTab]: updatedColumns,
    });
  };

  const title =
    messages.CERTS_EXPORT_ADD_TO_EXPORT ||
    localize(intl, getMessageKey('CERTS_EXPORT_ADD_TO_EXPORT'));

  const addAllText =
    messages.CERTS_EXPORT_ADD_ALL ||
    localize(intl, getMessageKey('CERTS_EXPORT_ADD_ALL'));

  return (
    <Box>
      <Box className='ColumnsHeader'>
        <Typography kind='body2'>{title}</Typography>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <Link
          text={addAllText}
          kind='button'
          onClick={() => addAll()}
          isDisabled={notIncludedColumns?.length === 0}
        />
      </Box>

      <Box className='AddToExportContainer'>
        {notIncludedColumns?.map((option) => (
          // eslint-disable-next-line jsx-a11y/label-has-associated-control, jsx-a11y/no-noninteractive-element-interactions
          <label
            key={option.id}
            className='AddToExportContainer-checkboxes'
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleChange(option?.id);
              }
            }}>
            <Checkbox
              id={option.id}
              name={option?.label}
              isChecked={option?.isChecked}
              onChange={() => handleChange(option?.id)}
              showHoverEffect
              isDisabled={option?.isDisabled}
              dataTestId={option?.id}
            />
            <Typography className='Certs-AddToExport-label' kind='body2'>
              {option?.label}
            </Typography>
          </label>
        ))}
      </Box>
    </Box>
  );
}

AddToExport.propTypes = {
  allColumnsData: PropTypes.shape({}).isRequired,
  setAllColumnsData: PropTypes.func.isRequired,
  selectedTab: PropTypes.string.isRequired,
};

export default AddToExport;
